import React from 'react';
import PropTypes from 'prop-types';
import PartnerFileListItem from './PartnerFileListItem';
import { Grid } from '@mui/material';

const PartnerFileList = ({ partnerFiles, fieldsToShow, onEdit }) => {
  return (
    <Grid container gap={2} my={2} flexDirection='column'>
      {partnerFiles.map(partnerFile => {
        return <PartnerFileListItem key={partnerFile.documentId} partnerFile={partnerFile} onEdit={onEdit} fieldsToShow={fieldsToShow} />;
      })}
    </Grid>
  );
};

PartnerFileList.propTypes = {
  partnerFiles: PropTypes.array.isRequired,
  onEdit: PropTypes.func.isRequired,
  fieldsToShow: PropTypes.array.isRequired
};

export default PartnerFileList;
